import { createTheme, MantineColorsTuple } from '@mantine/core';

const customDark: MantineColorsTuple = [
  '#C1C2C5',
  '#A6A7AB',
  '#909296',
  '#5C5F66',
  '#373A40',
  '#2C2E33',
  '#25262B',
  '#1A1B1E',
  '#141517',
  '#101113',
];

// Nvidia green color palette
const nvidiaGreen: MantineColorsTuple = [
  '#e8f9ed',
  '#d4f0dd',
  '#a8e1bb',
  '#78d196',
  '#52c376',
  '#3bba61',
  '#2eb856',
  '#1fa045',
  '#138f3a',
  '#007c2c',
];

// Webhallen blue (based on their brand blue)
const webhallenBlue: MantineColorsTuple = [
  '#e7f5ff',
  '#d0ebff',
  '#a5d8ff',
  '#74c0fc',
  '#4dabf7',
  '#339af0',
  '#228be6',
  '#1c7ed6',
  '#1971c2',
  '#1864ab',
];

// Proshop red (rgb(190, 0, 0))
const proshopRed: MantineColorsTuple = [
  '#ffe8e8',
  '#ffc9c9',
  '#ff9494',
  '#ff5c5c',
  '#ff2b2b',
  '#ff0909',
  '#be0000',
  '#a30000',
  '#8b0000',
  '#730000',
];

// Komplett yellow (rgb(248, 185, 18))
const komplettYellow: MantineColorsTuple = [
  '#fff9e0',
  '#fff3c7',
  '#ffe49a',
  '#ffd766',
  '#ffca3b',
  '#ffc01f',
  '#f8b912',
  '#dfa106',
  '#c38d00',
  '#a67700',
];

// Inet red (based on their logo red)
const inetRed: MantineColorsTuple = [
  '#ffe9e9',
  '#ffd0d0',
  '#ffa0a0',
  '#ff6b6b',
  '#ff4040',
  '#ff2525',
  '#e60000',
  '#cc0000',
  '#b30000',
  '#990000',
];

const amdRed: MantineColorsTuple = [
  '#ffe9e9',
  '#ffd0d0',
  '#ffa0a0',
  '#ff6b6b',
  '#ff4040',
  '#ff2525',
  '#e60000',
  '#cc0000',
  '#b30000',
  '#990000',
];

// Netonnet blue (RGB 0, 122, 179)
const netonnetBlue: MantineColorsTuple = [
  '#e5f5fb',
  '#cceaf7',
  '#99d4ee',
  '#66bfe6',
  '#33a9dd',
  '#1a9bd8',
  '#007ab3',
  '#006795',
  '#005477',
  '#004159',
];

// Amazon orange (based on their brand orange)
const amazonOrange: MantineColorsTuple = [
  '#fff4e6',
  '#ffe8cc',
  '#ffd8a8',
  '#ffc078',
  '#ffa94d',
  '#ff922b',
  '#fd7e14',
  '#f76707',
  '#e8590c',
  '#d9480f',
];

// CS MEGASTORE blue (#004874)
const csMegastoreBlue: MantineColorsTuple = [
  '#e0f2ff',
  '#b3deff',
  '#80c9ff',
  '#4db3ff',
  '#26a3ff',
  '#0091f5',
  '#0078cc',
  '#005fa3',
  '#004874',
  '#003352',
];

// Elgiganten green (rgb(73, 133, 10))
const elgigantenGreen: MantineColorsTuple = [
  '#f4f9e8',
  '#e6f2cc',
  '#d1e599',
  '#bcd961',
  '#aace34',
  '#9dc518',
  '#49850a',
  '#3d7008',
  '#325d07',
  '#264a05',
];

// Alina blue (rgb(0, 163, 224))
const alinaBlue: MantineColorsTuple = [
  '#e5f7fd',
  '#cceff9',
  '#99dff4',
  '#66cfef',
  '#33bfea',
  '#1ab4e7',
  '#00a3e0',
  '#008cc3',
  '#0075a6',
  '#005e89',
];

// DustinHome dark gray
const dustinHomeGray: MantineColorsTuple = [
  '#f5f5f5',
  '#e7e7e7',
  '#cdcdcd',
  '#b2b2b2',
  '#9a9a9a',
  '#8b8b8b',
  '#848484',
  '#717171',
  '#656565',
  '#575757',
];

const powerOrange: MantineColorsTuple = [
  '#fff4e6',
  '#ffe8cc',
  '#ffd8a8',
  '#ffc078',
  '#ffa94d',
  '#ff922b',
  '#f96700',
  '#e8590c',
  '#d9480f',
  '#c73a0f',
];

export const theme = createTheme({
  primaryColor: 'nvidiaGreen',
  defaultRadius: 'md',
  fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
  colors: {
    dark: customDark,
    nvidiaGreen: nvidiaGreen,
    webhallenBlue: webhallenBlue,
    proshopRed: proshopRed,
    komplettYellow: komplettYellow,
    inetRed: inetRed,
    amdRed: amdRed,
    netonnetBlue: netonnetBlue,
    amazonOrange: amazonOrange,
    csMegastoreBlue: csMegastoreBlue,
    elgigantenGreen: elgigantenGreen,
    alinaBlue: alinaBlue,
    dustinHomeGray: dustinHomeGray,
    powerOrange: powerOrange,
  },
  headings: {
    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
    fontWeight: '600',
  },
  components: {
    Table: {
      defaultProps: {
        striped: false,
        highlightOnHover: true,
        withTableBorder: false,
        withColumnBorders: false,
      },
    },
    Paper: {
      defaultProps: {
        radius: 'md',
        shadow: 'none',
      },
    },
    Button: {
      defaultProps: {
        radius: 'md',
      },
    },
    Badge: {
      defaultProps: {
        radius: 'sm',
      },
    },
  },
});
